import { createFileRoute } from '@tanstack/react-router'
import { ProjectList } from '@/modules/project-hub/pages/ProjectList'

export const Route = createFileRoute('/projects/')({
  component: ProjectList,
})
